import React, { Component } from 'react';
import '../../App.css';
import BannerPrincipal from './banner-principal'
import BannerVideo from './banner-video'
import Row from '../reusables/row'
import Products from './products'
import Categories from './categories'
import Certifications from '../reusables/certifications'
import Footer from '../reusables/footer'

import videoprincipal from '../../video/video1.mp4'
import videorosas from '../../video/rose.mp4'
import videocamarones from '../../video/camarones.mp4'

class home extends Component {
  render() {
    return (
      <div className="home">
        {/* <Navbar/> */}
        <BannerPrincipal video={[videoprincipal]}
                title={['Pioricost Fruit']}
                linkto={["pioricost-fruit"]}
                description={['Pioricost FruitBecause of our geographical location, the banana is "larger, more homogenous in consistency and has a different, more intense flavour", which is why the Ecuadorian banana is the best in the world.']}/>
        <Row label={['Message from the Board of Directors']}
             description={['"The development of a country is not a product of luck, but of clear and correct political decisions, hand in hand with innovation and private investment. INEXLAM C.A. is committed to contributing and combining these metrics for the development of Ecuador.']}
             author={['Antonio Tovar']}
             charge={['President and Executive Director of INEXLAM C.A.']}
             description2={['"Trade, as a fundamental activity of any country, incorporates not only the exchange of products but the implementation of social relations with strategic partners, INEXLAM C.A. works every day for the strengthening and growth of national and international trade".']}
             author2={['Jair Tovar']}
             charge2={['GENERAL MANAGER OF INEXLAM.C.A']}/>
        <Products/>
        <Row label={['Message from the Board of Directors']}
             description={['"The development of a country is not a product of luck, but of clear and correct political decisions, hand in hand with innovation and private investment. INEXLAM C.A. is committed to contributing and combining these metrics for the development of Ecuador.']}
             author={['Antonio Tovar']}
             charge={['President and Executive Director of INEXLAM C.A.']}
             description2={['"Trade, as a fundamental activity of any country, incorporates not only the exchange of products but the implementation of social relations with strategic partners, INEXLAM C.A. works every day for the strengthening and growth of national and international trade".']}
             author2={['Jair Tovar']}
             charge2={['GENERAL MANAGER OF INEXLAM.C.A']}/>
        {/* <Banner image={[bannersecundario]}
                title={['Lorem ipsum dolor sit amet, consectetur']}
                description={['Adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.']}/> */}
        
        <BannerVideo video={[videocamarones]}
                title={['Pioricost Fish']}
                linkto={['']}
                description={['FishFresh, size, environmental care, quality and social factor have been the pillars that have led the Ecuadorian shrimp to become the most demanded worldwide, and dethroned the banana, as the first non-oil export product of the country.']}/>
        <Categories/>
        <Row label={['Message from the Board of Directors']}
             description={['"The development of a country is not a product of luck, but of clear and correct political decisions, hand in hand with innovation and private investment. INEXLAM C.A. is committed to contributing and combining these metrics for the development of Ecuador.']}
             author={['Antonio Tovar']}
             charge={['President and Executive Director of INEXLAM C.A.']}
             description2={['"Trade, as a fundamental activity of any country, incorporates not only the exchange of products but the implementation of social relations with strategic partners, INEXLAM C.A. works every day for the strengthening and growth of national and international trade".']}
             author2={['Jair Tovar']}
             charge2={['GENERAL MANAGER OF INEXLAM.C.A']}/>
        <BannerVideo video={[videorosas]}
                title={['Pioricost Roses']}
                linkto={['']}
                description={['Shops as exclusive as Roseonly in China have made the Ecuadorian rose a symbol of exclusivity, elegance, good taste, variety and above all quality.']}/>
        <Certifications/>
        <Footer/>
      </div>
    );
  }
}

export default home;


// WEBPACK FOOTER //
// ./src/components/en-home/index.js